import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Injector, Input, Output, ViewChild } from '@angular/core';
import { NgControl, FormControl, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../../services/user.service';
import environment from '../../../environments/environment';
import * as Papa from 'papaparse';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-file-uploader',
  imports: [CommonModule],
  templateUrl: './file-uploader.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: FileUploaderComponent
    }
  ],
  standalone: true,
})
export class FileUploaderComponent implements ControlValueAccessor {
  @Output() file_uploaded = new EventEmitter<any>();
  @Input() multiple: boolean = false;
  @Input() uploaderVariant: 'default' | 'photo-box' = 'default';
  @Input() photoBoxSize: 'sm' | 'md' | 'lg' = 'md';
  @Input() is_required: boolean = false;
  @Input() lebal: any = '';
  @Input() disabled: boolean = false;
  @Input() accept: string = '.jpg,.jpeg,.webp,.png';
  @Input() maxFileSize: number = 10;
  @Input() sub_text: string = '';
  @Input() box_clickable: boolean = true;
  @Input() box_aspect: string = 'aspect-square';
  @Input() box_icon: 'landscape' | 'person' = 'landscape';
  @Input() custom_format_error_msg: string = '';
  @Input() custom_size_error_msg: string = '';
  imageSizes: string[] = [];
  images: string[] = [];
  imageNames: string[] = [];
  params: any;
  paramValue: any = {}
  isDragging: boolean = false;

  @ViewChild('photoBoxInput') photoBoxInput: ElementRef<HTMLInputElement> | undefined;

  private onChange: any = () => { };
  private onTouched: any = () => { };

  triggerUpload() {
    this.photoBoxInput?.nativeElement?.click();
  }

  constructor(public ar: ActivatedRoute, private injector: Injector, public us: UserService) { }

  ngOnInit(): void {
    this.ar.queryParams.subscribe(params => {
      this.paramValue = params;
    });
  }
  control: any;
  ngAfterViewInit(): void {
    setTimeout(() => {
      const ngControl: NgControl | null = this.injector.get(NgControl, null);
      if (ngControl) {
        this.control = ngControl.control as FormControl;
      } else {
        // Component is missing form control binding
      }
    }, 100);
  }
  writeValue(value: any): void {
    if (value) {
      this.images = this.multiple ? value : [value];
      console.log(this.images, 'value');

    } else {
      this.images = [];
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled
  }

  get photoBoxSizeClass(): string {
    if (this.photoBoxSize === 'lg') {
      return 'w-44 h-44 sm:w-48 sm:h-48';
    }
    if (this.photoBoxSize === 'sm') {
      return 'w-28 h-28 sm:w-32 sm:h-32';
    }
    return 'w-32 h-32 sm:w-36 sm:h-36';
  }


  //   async onImageSelected(event: any) {
  //     console.log(event,this.control.value);

  //   const files: FileList = event.target.files;
  //   if (!files?.length) return;

  //   for (const file of Array.from(files)) {
  //     try {
  //       const res: any = await this.us.upload_image(file);
  //       console.log('Binary Upload Response:', res);

  //       const imageUrl = environment.url + res?.file_path;
  //       console.log(imageUrl,99999);
  //       console.log(environment.url,'llllll');


  //       if (this.multiple) {
  //         this.images.push(imageUrl);
  //         this.imageNames.push(file.name);
  //         this.onChange(this.images);
  //       } else {
  //         this.images = [imageUrl];
  //         this.imageNames = [file.name];
  //         this.onChange(imageUrl);
  //       }

  //     } catch (err) {
  //       console.error('Binary upload failed', err);
  //     }
  //   }
  // }


  // -------x------
  // async onImageSelected(event: any) {
  //   const files: FileList = event.target.files;
  //   if (!files?.length) return;

  //   for (const file of Array.from(files)) {
  //     try {
  //       const res: any = await this.us.upload_image(file);
  //       const filePath = res;

  //       if (!filePath) {
  //         console.error('file_path not found in upload response');
  //         continue;
  //       }

  //       if (this.multiple) {
  //         this.images.push(filePath.file_path);
  //         this.imageNames.push(file.name);
  //         this.onChange(this.images);
  //       } else {
  //         this.images = [filePath.file_path];
  //         this.imageNames = [file.name];
  //         this.onChange(filePath);
  //       }

  //     } catch (err) {
  //       console.error('File upload failed', err);
  //     }
  //   }
  //   this.onTouched();
  // }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
    const files = event.dataTransfer?.files;
    if (files?.length) {
      this.onImageSelected({ target: { files } });
    }
  }

  async onImageSelected(event: any) {
    const files: FileList = event.target.files;
    if (!files?.length) return;

    const maxSizeInBytes = this.maxFileSize * 1024 * 1024;
    const allowedExtensions = this.accept.split(',').map(e => e.trim().toLowerCase().replace('.', ''));

    for (const file of Array.from(files)) {
      const extension = file.name.split('.').pop()?.toLowerCase() || '';

      // FORMAT VALIDATION
      if (allowedExtensions.length && !allowedExtensions.includes(extension)) {
        alert(this.custom_format_error_msg || `Only ${this.accept} files are allowed.`);
        continue;
      }

      // FILE SIZE VALIDATION
      if (file.size > maxSizeInBytes) {
        alert(this.custom_size_error_msg || `File size should be less than ${this.maxFileSize} MB`);
        continue;
      }

      try {
        const res: any = await this.us.upload_image(file);
        const imageUrl = environment.url + res?.file_path;

        if (this.multiple) {
          this.images.push(imageUrl);
          this.imageNames.push(file.name);
          this.imageSizes.push(this.formatBytes(file.size));
          this.onChange(this.images);
        } else {
          this.images = [imageUrl];
          this.imageNames = [file.name];
          this.imageSizes = [this.formatBytes(file.size)];
          this.onChange(imageUrl);
        }
        if (extension === 'csv' || extension === 'xls' || extension === 'xlsx') {
          let parsed_document_data = await this.parse_file_by_extension(file, extension);
          this.file_uploaded.emit(parsed_document_data)
        }


      } catch (err) {
        console.error('Upload failed', err);
      }
    }
    this.onTouched();
  }

  formatBytes(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }



  removeImage(index: number) {
    this.images.splice(index, 1);
    this.imageSizes.splice(index, 1);
    this.imageNames.splice(index, 1);
    if (this.multiple) {
      this.onChange(this.images);
    } else {
      this.onChange('');
    }
  }



  // view_image(index: number) {
  //   const file = this.images[index];
  //   // Check if it's a base64 image or PDF
  //   const isImage = file.startsWith('data:image');
  //   const isPdf = file.startsWith('data:application/pdf');

  //   if (file && (isImage || isPdf)) {
  //     const newWindow = window.open();
  //     if (newWindow) {
  //       newWindow.document.write(
  //         `<iframe src="${file}" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>`
  //       );
  //     }
  //   } else {
  //     // Fallback to download
  //     const link = document.createElement('a');
  //     link.href = this.images[index];
  //     link.download = this.imageNames[index] || `${this.lebal}_Template`;
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   }
  // }

  view_image(index: number) {
    const fileUrl = this.images[index];
    const fileName = this.imageNames[index] || '';
    if (!fileUrl) return;

    // Get file extension
    const extension = fileName.split('.').pop()?.toLowerCase() || '';

    // Determine file type
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
    const pdfExtensions = ['pdf'];
    const videoExtensions = ['mp4', 'webm', 'ogg', 'mov', 'avi'];
    const audioExtensions = ['mp3', 'wav', 'ogg', 'aac'];
    const textExtensions = ['txt', 'json', 'xml', 'html', 'css', 'js', 'ts'];
    const documentExtensions = ['csv', 'xlsx', 'xls'];

    const isImage = imageExtensions.includes(extension) || fileUrl.includes('image') || this.accept.includes('image');
    const isPdf = pdfExtensions.includes(extension) || fileUrl.includes('pdf');
    const isVideo = videoExtensions.includes(extension);
    const isAudio = audioExtensions.includes(extension);
    const isText = textExtensions.includes(extension);
    const isDocument = documentExtensions.includes(extension);

    const newWindow = window.open('', '_blank');
    if (!newWindow) return;

    // Handle data URIs
    if (fileUrl.startsWith('data:')) {
      newWindow.document.write(`
        <html>
          <head>
            <title>${fileName || 'Preview'}</title>
            <style>
              body { margin: 0; padding: 0; display: flex; justify-content: center; align-items: center; min-height: 100vh; background: #f5f5f5; }
              img { max-width: 100%; max-height: 100vh; object-fit: contain; }
              iframe { width: 100%; height: 100vh; border: none; }
            </style>
          </head>
          <body>
            <iframe src="${fileUrl}" frameborder="0" style="width:100%;height:100%" allowfullscreen></iframe>
          </body>
        </html>
      `);
      return;
    }

    // Handle different file types for regular URLs
    if (isImage) {
      newWindow.document.write(`
        <html>
          <head>
            <title>${fileName || 'Image Preview'}</title>
            <style>
              body { margin: 0; padding: 20px; display: flex; justify-content: center; align-items: center; min-height: 100vh; background: #f5f5f5; }
              img { max-width: 100%; max-height: 100vh; object-fit: contain; box-shadow: 0 4px 6px rgba(0,0,0,0.1); }
            </style>
          </head>
          <body>
            <img src="${fileUrl}" alt="${fileName}" />
          </body>
        </html>
      `);
    } else if (isPdf) {
      newWindow.document.write(`
        <html>
          <head>
            <title>${fileName || 'PDF Preview'}</title>
            <style>
              body { margin: 0; padding: 0; }
              iframe { width: 100%; height: 100vh; border: none; }
            </style>
          </head>
          <body>
            <iframe src="${fileUrl}" type="application/pdf"></iframe>
          </body>
        </html>
      `);
    } else if (isVideo) {
      newWindow.document.write(`
        <html>
          <head>
            <title>${fileName || 'Video Preview'}</title>
            <style>
              body { margin: 0; padding: 20px; display: flex; justify-content: center; align-items: center; min-height: 100vh; background: #000; }
              video { max-width: 100%; max-height: 100vh; }
            </style>
          </head>
          <body>
            <video controls autoplay>
              <source src="${fileUrl}" type="video/${extension}">
              Your browser does not support the video tag.
            </video>
          </body>
        </html>
      `);
    } else if (isAudio) {
      newWindow.document.write(`
        <html>
          <head>
            <title>${fileName || 'Audio Preview'}</title>
            <style>
              body { margin: 0; padding: 40px; display: flex; flex-direction: column; justify-content: center; align-items: center; min-height: 100vh; background: #f5f5f5; font-family: Graphik, Arial, sans-serif; }
              h2 { color: #333; margin-bottom: 20px; }
              audio { width: 100%; max-width: 500px; }
            </style>
          </head>
          <body>
            <h2>${fileName}</h2>
            <audio controls autoplay>
              <source src="${fileUrl}" type="audio/${extension}">
              Your browser does not support the audio tag.
            </audio>
          </body>
        </html>
      `);
    } else if (isText) {
      // Fetch and display text content
      fetch(fileUrl)
        .then(response => response.text())
        .then(text => {
          newWindow.document.write(`
            <html>
              <head>
                <title>${fileName || 'Text Preview'}</title>
                <style>
                  body { margin: 0; padding: 20px; background: #fff; font-family: monospace; }
                  pre { white-space: pre-wrap; word-wrap: break-word; }
                </style>
              </head>
              <body>
                <pre>${this.escapeHtml(text)}</pre>
              </body>
            </html>
          `);
        })
        .catch(() => {
          newWindow.location.href = fileUrl;
        });
    } else if (isDocument) {
      // For CSV/Excel files, show download option
      newWindow.document.write(`
        <html>
          <head>
            <title>${fileName || 'Document Preview'}</title>
            <style>
              body { margin: 0; padding: 40px; font-family: Graphik, Arial, sans-serif; background: #f5f5f5; }
              .container { max-width: 600px; margin: 0 auto; background: white; padding: 40px; border-radius: 8px; box-shadow: 0 2px 10px rgba(0,0,0,0.1); text-align: center; }
              h2 { color: #333; margin-bottom: 10px; }
              p { color: #666; margin-bottom: 30px; }
              .download-btn { display: inline-block; padding: 12px 24px; background: #3F41D1; color: white; text-decoration: none; border-radius: 6px; font-weight: 500; transition: background 0.3s; }
              .download-btn:hover { background: #2f31a1; }
              .file-icon { font-size: 64px; color: #3F41D1; margin-bottom: 20px; }
            </style>
          </head>
          <body>
            <div class="container">
              <div class="file-icon">📄</div>
              <h2>${fileName}</h2>
              <p>Click below to download and view this ${extension.toUpperCase()} file</p>
              <a href="${fileUrl}" download="${fileName}" class="download-btn">Download File</a>
            </div>
          </body>
        </html>
      `);
    } else {
      // For other file types, show download option
      newWindow.document.write(`
        <html>
          <head>
            <title>${fileName || 'File Preview'}</title>
            <style>
              body { margin: 0; padding: 40px; font-family: Graphik, Arial, sans-serif; background: #f5f5f5; }
              .container { max-width: 600px; margin: 0 auto; background: white; padding: 40px; border-radius: 8px; box-shadow: 0 2px 10px rgba(0,0,0,0.1); text-align: center; }
              h2 { color: #333; margin-bottom: 10px; }
              p { color: #666; margin-bottom: 30px; }
              .download-btn { display: inline-block; padding: 12px 24px; background: #3F41D1; color: white; text-decoration: none; border-radius: 6px; font-weight: 500; transition: background 0.3s; }
              .download-btn:hover { background: #2f31a1; }
              .file-icon { font-size: 64px; color: #3F41D1; margin-bottom: 20px; }
            </style>
          </head>
          <body>
            <div class="container">
              <div class="file-icon">📎</div>
              <h2>${fileName}</h2>
              <p>This file type cannot be previewed directly in the browser</p>
              <a href="${fileUrl}" download="${fileName}" class="download-btn">Download File</a>
            </div>
          </body>
        </html>
      `);
    }
  }

  private escapeHtml(text: string): string {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }


  parse_file_by_extension(file: File, extension: string): Promise<any[]> {
    return new Promise((resolve, reject) => {
      const ext = extension.toLowerCase();

      // ✅ CSV
      if (ext === 'csv') {
        Papa.parse(file, {
          header: true,
          skipEmptyLines: true,
          complete: (result) => {
            resolve(result.data as any[]);
          },
          error: (error) => {
            reject(error);
          }
        });
        return;
      }

      // ✅ EXCEL (XLS / XLSX)
      if (ext === 'xls' || ext === 'xlsx') {
        const reader = new FileReader();

        reader.onload = (e: any) => {
          try {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: '' });
            resolve(jsonData as any[]);
          } catch (err) {
            reject(err);
          }
        };

        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
        return;
      }

      // ❌ Unsupported type
      reject(new Error(`Unsupported file extension: ${extension}`));
    });
  }

  downloadTemplate(): void {
    const link = document.createElement('a');
    link.href = '/assets/rubric_template.csv';
    link.download = 'rubric_template.csv';
    link.click();
  }

}
